// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"389":"c3c2e31d7155d85f8ae7","524":"d2094c3b84551595fda0"}[chunkId] + ".css";
};